<div class="gridContainer">

    <h1 class="goBack" (click)="goBack()">
        Obligoliste anfordern
    </h1>

    <h2>
        Vertragsauswahl

        <div class="options">
            <span class="hinweis">* Pflichtfelder</span>
        </div>
    </h2>

    <div class="gridContainer formGrid fitGrid">

        @if (vertraege() && vertraege().length > 0) {
            <div class="row">
                <div class="cell grid-25">
                    <label for="f_versicherungsscheinnr"><strong>Versicherungsschein-Nr.:&nbsp;*</strong></label>
                </div>
                <div class="cell grid-50">
                    <select id="f_versicherungsscheinnr"
                            name="f_versicherungsscheinnr"
                            [(ngModel)]="model.vsnrSelection.value"
                            [class.error]="model.vsnrSelection.valid === false"
                            [disabled]="vertragsListeDisabled()"
                            required>
                        @if (vertraege().length > 1) {
                            <option value="" selected="selected">Bitte wählen</option>
                            <option value="all">Alle Versicherungsnummern</option>
                        }
                        @for (vertrag of vertraege(); track vertrag.vsnrNumerisch) {
                            <option [value]="vertrag.vsnrNumerisch">{{ vertrag.vsnrFormatiert }}</option>
                        }
                    </select>
                    @if (model.vsnrSelection.valid === false) {
                        <div class="errorMessage" [innerHTML]="model.vsnrSelection.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>

            <div class="row">
                <div class="cell grid-25">
                    <label for="f_only_in_risk"><strong>Obligoliste umfasst:</strong></label>
                </div>
                <div class="cell grid-50">
                    <select id="f_only_in_risk"
                            name="f_versicherungsscheinnr"
                            [(ngModel)]="model.onlyInRisk.value"
                            (change)="notifyRisk()"
                            required>
                        <option value="im_risiko">im Risiko befindliche Bürgschaften</option>
                        <option value="alle">alle Bürgschaften</option>
                    </select>
                </div>
                <div class="cell grid-25">
                </div>
            </div>

            @if (dateSelectionVisible()) {
                <div class="row">
                    <div class="cell grid-25 alignr">
                        <label for="datumVon"><strong>Bürgschaften vom:&nbsp;*</strong></label>
                    </div>
                    <div class="cell grid-25">
                        <input type="date"
                               id="datumVon"
                               name="f_buergschaft_vom"
                               placeholder="TT.MM.JJJJ"
                               [ngModel]="model.datumVon.value | dateValue2DateInputPipe"
                               (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.datumVon, $event)"
                               [class.error]="model.datumVon.valid === false"
                               (blur)="model.validateField(model.datumVon)"
                               (keyup)="onInputFieldKeyUp($event)">
                        @if (model.datumVon.valid === false) {
                            <div class="errorMessage" [innerHTML]="model.datumVon.errorMsg"></div>
                        }
                    </div>
                    <div class="cell grid-50">
                        <elem-button buttonRole="SECONDARY" (click)="datumVorbelegungDiesesJahr()">
                            Dieses Jahr
                        </elem-button>
                        <elem-button buttonRole="SECONDARY" (click)="datumVorbelegungLetztesJahr()" style="margin-left: 1rem;">
                            Letztes Jahr
                        </elem-button>
                    </div>
                </div>

                <div class="row">
                    <div class="cell grid-25 alignr">
                        <label for="datumBis"><strong>bis:&nbsp;*</strong></label>
                    </div>
                    <div class="cell grid-25">
                        <input type="date"
                               id="datumBis"
                               name="f_buergschaft_bis"
                               placeholder="TT.MM.JJJJ"
                               [ngModel]="model.datumBis.value | dateValue2DateInputPipe"
                               (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.datumBis, $event)"
                               [class.error]="model.datumBis.valid === false"
                               (blur)="model.validateField(model.datumBis)"
                               (keyup)="onInputFieldKeyUp($event)">
                        @if (model.datumBis.valid === false) {
                            <div class="errorMessage" [innerHTML]="model.datumBis.errorMsg"></div>
                        }
                    </div>
                    <div class="cell grid-50"></div>
                </div>
            }

            <div class="row">
                <div class="cell grid-25">
                    <label><strong>Liste herunterladen als:</strong></label>
                </div>
                <div class="cell grid-25">
                    <input type="radio"
                           name="f_dateiformat"
                           value="csv"
                           id="f_dateiformat_csv"
                           [(ngModel)]="model.requiredFormat.value">
                    <label for="f_dateiformat_csv">CSV</label>
                </div>
                <div class="cell grid-50">
                    <input type="radio"
                           name="f_dateiformat"
                           value="pdf"
                           id="f_dateiformat_pdf"
                           [(ngModel)]="model.requiredFormat.value">
                    <label for="f_dateiformat_pdf">PDF</label>
                </div>
            </div>

            <div class="row trenner"></div>

            <div class="row">
                <div class="cell grid-75"></div>
                <div class="cell grid-25">
                    <elem-button buttonRole="PRIMARY" class="expand" (click)="downloadObligoliste()" [disabled]="downloadButtonDisabled()">
                        Liste anfordern
                    </elem-button>
                </div>
            </div>

        } @else {
            <p>Es wurden keine Verträge gefunden.</p>
        }

        </div>

</div>
